export class MathUtils {

    static sum(data: any[]) {
        return data.reduce((total, currentRow) => total + currentRow, 0);
    }

    static avg(data: any[]) {
        return data.reduce((total, currentRow) => total + currentRow, 0) / data.length;
    }

    static min(data: any[]) {
        return data.reduce((min, currentRow) =>
            // eslint-disable-next-line eqeqeq
            min == undefined || min > currentRow ? currentRow : min, undefined);
    }

    static max(data: any[]) {
        return data.reduce((max, currentRow) =>
            // eslint-disable-next-line eqeqeq
            max == undefined || max < currentRow ? currentRow : max, undefined);
    }

    static round(value: number) {
        return Math.round(value);
    }

    static increase(a: number, b: number) {
        if (!a || !b) {
            return 0;
        }

        const internalIncrease = (v1: number, v2: number) => Math.abs((v1 - v2) / v2);
        return a > b ? internalIncrease(a, b) : internalIncrease(b, a);
    }
}
